import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
deleteVideosAction,
deleteVideosrelatedAction,
readLanguageAction,
readVideosAction,
saveCommonsUrlsAction,
saveDownloadVideoUrlLanguageAction,
saveVideoLanguageAction,
saveVideoPreviewLanguageAction,
saveVideoPreviewUrlsAction,
saveVideoUrlLanguageAction,
saveVideosAction,
saveVideosDownloadUrlsAction,
saveVideosThumbNailUrlsAction,
saveVideosUrlsAction,
saveVideosrelatedAction,
translateLanguageAction,
updateCommonsUrlsAction,
updateDownloadVideoUrlLanguageAction,
updateVideoLanguageAction,
updateVideoPreviewLanguageAction,
updateVideoPreviewUrlsAction,
updateVideoUrlLanguageAction,
updateVideosAction,
updateVideosDownloadUrlsAction,
updateVideosThumbNailUrlsAction,
updateVideosUrlsAction,
uploadAssestsAction,
uploadAssestsV2Action,
uploadVideosV2Action,
} from "../../../store/Languages/LanguageAction";
import Toastiy from "../../../components/universal/Toastiy";
import { useNavigate } from "react-router-dom";
import {
deleteVideoLayoutAction,
readVideoLayoutAction,
saveVideoLayoutAction,
updateVideoLayoutAction,
} from "../../../store/Layout/LayoutAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { sendCustomNotificationAction } from "../../../store/Notifications/NotificationAction";
import { fetchChannelsRequest } from "../../../store/Channels/action";
import { saveChannelRequest,deleteChannelRequest,updateChannelRequest } from "../../../store/Channels/action"; // ✅ import save action
import { toast } from "react-toastify";

const ChurchHooks = () => {
const [value, setValue] = useState("");
const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

return { value, onChangeSearchBar };
};

export default ChurchHooks;

export const AllChurchHooks = () => {
const dispatch = useDispatch();

const [value, setValue] = useState("");
const [reloadData, setReloadData] = useState(false);
const fetchAllChurches = (page, limit, searchCriteria = {}, callbackFn,churchId) => {
    dispatch(
      fetchChannelsRequest({
        apiPayloadRequest: {
          page,
          limit,
          searchCriteria,
          typeofentity: 2,
          _id:churchId,

        },
        callback: (Data) => {

          const directList = Array.isArray(Data?.data) ? Data.data : [];
          const nestedList = Array.isArray(Data?.data?.data) ? Data.data.data : [];
          const listData = directList.length ? directList : nestedList;

          if (Data?.type === 1) {
            const normalizedData = listData.map((d) => ({
              ...d,
              church_name: d?.churchName ?? "Unnamed Church", // ✅ match your API field
              church_address: d?.address ?? "No Address",
              church_description: d?.description ?? "",
            }));

            if (callbackFn) {
              callbackFn({
                data: normalizedData,
                total:
                  Data?.totalRecords ??
                  Data?.data?.totalRecords ??
                  normalizedData.length,
                pageNum: page, // ✅ no pageNum in API → fallback
              });
            }
          } else {
            if (callbackFn) {
              callbackFn({
                data: [],
                total: 0,
                pageNum: page,
              });
            }
          }
        },
      })
    );
  };


const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};
const handleDelete = (row) => {
    return new Promise((resolve, reject) => {
      dispatch(
        deleteChannelRequest({
          _id: row._id,
          callback: (res) => {
            if (res.type === 1) {
              toast.success("Church Deleted Successfully");
              resolve(res); // resolves the promise on success
            } else {
              Toastiy("Delete failed: " + res.error);
              reject(res);  // rejects the promise on failure
            }
          },
        })
      );
    });
  };



return {
    value,
    onChangeSearchBar,
    handleDelete,
    reloadData,
    setReloadData,
    fetchAllChurches
};
};

export const AddChurchHooks = (setLoading, data) => {

// search logic here
const [options, setOptions] = useState([]);
const [value, setValue] = useState("");
const [activeTab, setActiveTab] = useState("en");
const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
});
const [allLanguageData, setAllLanguageData] = useState([]);
const [readLanguageData, setReadLanguageData] = useState([]);
const [selectedOptions, setSelectedOptions] = useState([]);
const [selectedRelatedVideoIndex, setSelectedRelatedVideoIndex] = useState(null);
const [relatedVideos, setRelatedVideos] = useState([]);
const [imageSet,setimageSet]=useState()
const dispatch = useDispatch();

const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};
// add category logic here

const initialLayoutValues = {
    _id: "",
    mobile_layout: "1",
    layout_name: "",
    order: "",
    // title: "",
    // subtitle: "",
    // expiry: "",
};

const initialVideoValues = {
    video_title: "",
    video_description: "",
    _id: "",
};

const [layoutValues, setLayoutValues] = useState(initialLayoutValues);
const [addedLayout, setAddedLayout] = useState(false);

const initialStateValues = {
    mobileUploadUrl: "",
    webUploadUrl: "",
    tabletUploadUrl: "",
};

const languages = [
    "English",
    "hindi",
    "tamil",
    "telugu",
    "Malayalam",
    "Spanish",
    "Marathi",
    "Urdu",
    "Oriya",
    "kanada",
    "Bengali",
]; // List of languages

const [downloadValues, setDownloadValues] = useState("");
const [downloadUrl, setDownloadUrl] = useState("");
const [thumbNailValues, setThumbNailValues] = useState("");
const [thumbNailUrl, setThumbNailUrl] = useState("");
const [inputs, setInputs] = useState("");
const [showVideoLibraryModal, setShowVideoLibraryModal] = useState(false);
const [videoInputs, setVideoInputs] = useState(initialVideoValues);
const [videoErrors, setVideoErrors] = useState({
    video_title: false,
    video_description: false,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    selectedOptions: false,
});

const [currentInputs, setCurrentInputs] = useState();
const [languagemeta, setLanguagemeta] = useState();

const [videoUrlsInputs, setVideoUrlsInputs] = useState(initialStateValues);
const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState(initialStateValues);
const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState(initialStateValues);
const [commonVideoUrlsInputs, setCommonUrlsInputs] = useState(initialStateValues);
const [previewUrlsInputs, setPreviewUrlsInputs] = useState(initialStateValues);

const [videoUrlsInputsCheck, setVideoUrlsInputsCheck] = useState();
const [UdownloadrlsInputsCheck, setDownloadUrlsInputsCheck] = useState();
const [tumbNailUrlsInputsCheck, setTumbNailUrlsInputsCheck] = useState();
const [commonUrlsInputsCheck, setCommonUrlsInputsCheck] = useState();
const [previewUrlsInputsCheck, setPreviewUrlsInputsCheck] = useState();
const [layoutInfo, setLayoutInfo] = useState(false);
const [layoutArray, setLayoutArray] = useState([]);
const [isLayoutEdit, setIsLayoutEdit] = useState(false);
const [editLayoutIndex, setEditLayoutIndex] = useState(null);
const [editTargetLayout, setEditTargetLayout] = useState("");

const initialChurchValues = {
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
    church_email: "",
    church_phone: "",
    church_website: "",
    church_latitude: "",
    church_longitude: "",
    logo_url:'',
    church_giver_url:''
};
const [churchInputs, setChurchInputs] = useState(initialChurchValues);
// 🔹 State for previous (existing) values when editing
const [previousChurchInputs, setPreviousChurchInputs] = useState({
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
});

// 🔹 Validation errors
const [churchErrors, setChurchErrors] = useState({
    church_name: false,
    church_description: false,
    church_address: false,
});

// 🔹 Loader (renamed)
const [savingChurch, setSavingChurch] = useState(false);

// 🔹 Local store for churches (instead of DB)
const [churches, setChurches] = useState([]);
const [saveSuccess, setSaveSuccess] = useState(false);


const navigate = useNavigate();


useEffect(() => {
    return () => setShowNavigationAlert(false);
}, []);

const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
};

const combineStateKeys = () => {
    const values = Object.values({
    video_title: videoInputs?.video_title,
    video_description: videoInputs?.video_description,
    });
    const combinedString = values.join("///");
    return combinedString;
};

const updateStateWithTranslation = () => {
    const combinedText = combineStateKeys();

    dispatch(
    translateLanguageAction({
        apiPayloadRequest: {
        targetcode: activeTab,
        translatetext: combinedText,
        },
        callback: (res) => {
        if (res?.type === 1) {
            onTranslateSuccess(res?.data);
        } else if (res?.type === 2) {
            Toastiy("Language Translation failed!!");
            Toastiy(res?.message);
        }
        },
    })
    );
};

const onTranslateSuccess = (data) => {
        const arrayOfValues = data.split("///");
    const arrayOfKeys = Object.keys({
    video_title: videoInputs?.video_title,
    video_description: videoInputs?.video_description,
    });

    for (let key in arrayOfKeys) {
    setVideoInputs((preState) => ({
        ...preState,
        [arrayOfKeys[key]]: arrayOfValues[key],
    }));
    }
    setShowNavigationAlert(true);
};

// const getRelatedVideos = (response) => {
//     if (response?.type === 1) {
//     response?.data?.map((item) =>
//         setOptions((prevData) => [
//         ...prevData,
//         {
//             value: item?._id || "",
//             label: item?.video_title || "",
//             image: item?.tumbnailurls?.length > 0 ? item?.tumbnailurls[0]?.url_link : "",
//         },
//         ])
//     );
//     } else {
//     Toastiy("Failed To Get Related Videos Data");
//     }
// };

const handleAddLayoutToArray = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        saveVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // expiry: layoutValues?.expiry,
            // title: layoutValues?.title,
            // subtitle: layoutValues?.subtitle,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Layout Added Successfully!", 1);
            setLayoutArray((prev) => [...prev, layoutValues]);
            setLayoutValues(initialLayoutValues);
            setAddedLayout(true);
            }
        },
        })
    );
    } else {
    setLayoutArray((prev) => [...prev, layoutValues]);
    setLayoutValues(initialLayoutValues);
    setAddedLayout(true);
    }
};

const handleDeleteLayoutFromArray = (id) => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        deleteVideoLayoutAction({
        apiPayloadRequest: {
            _id: id,
            videoObjId: videoInputs?._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            const updatedArray = layoutArray.filter((item) => item._id !== id);
            setLayoutArray(updatedArray);
            Toastiy("Layout Deleted Successfully!", 1);
            }
        },
        })
    );
    } else {
    const updatedArray = layoutArray.filter((item) => item._id !== id);
    setLayoutArray(updatedArray);
    }
};

const handleLayoutUpdate = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        updateVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // title: layoutArray._id,
            // subtitle: layoutArray._id,
            // expiry: layoutArray._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            setLayoutValues(initialLayoutValues);
            setIsLayoutEdit(false);
            Toastiy("Layout Updated Successfully!", 1);
            setShowNavigationAlert(false);
            }
        },
        })
    );
    } else {
    setLayoutValues(initialLayoutValues);
    setIsLayoutEdit(false);
    setShowNavigationAlert(true);
    }
};

const handleDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleVideoLayoutChange = (event) => {
    if (isLayoutEdit) {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));

    setLayoutArray((prev) => {
        const updatedArray = [...prev];

        updatedArray[editLayoutIndex] = {
        ...updatedArray[editLayoutIndex],
        [name]: value,
        };
        return updatedArray;
    });
    } else {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));
    setShowNavigationAlert(true);
    }
};

const handleVideoDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleDropdownChange = (selectedValues) => {
                const videoItem = {
    value: selectedValues?._id,
    label: selectedValues?.video_title,
    image:
        selectedValues?.tumbnailurls?.length > 0 ? selectedValues?.tumbnailurls[0]?.url_link : "",
    order:
        selectedRelatedVideoIndex !== null
        ? selectedOptions[selectedRelatedVideoIndex]?.order
        : selectedOptions?.length + 1,
    };

    if (data?._id !== "" && data?._id !== undefined) {
    if (selectedRelatedVideoIndex !== null && selectedOptions[selectedRelatedVideoIndex]?.value) {
        dispatch(
        deleteVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: selectedOptions[selectedRelatedVideoIndex]?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                //show message
                dispatch(
                saveVideosrelatedAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    videoObjId: videoItem?.value,
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Related Video Updated Successfully!", 1);
                        setSelectedOptions((prev) =>
                        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
                        );
                    } else {
                        Toastiy("Failed to Update Video");
                    }
                    },
                })
                );
            }
            },
        })
        );
    } else {
        dispatch(
        saveVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoItem?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                Toastiy("Related Video Added Successfully!", 1);
                setSelectedOptions((prev) => [...prev, videoItem]);
            } else {
                Toastiy("Failed to Add Video");
            }
            },
        })
        );
    }
    } else {
    if (selectedRelatedVideoIndex !== null) {
        setSelectedOptions((prev) =>
        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
        );
    } else {
        setSelectedOptions((prev) => [...prev, videoItem]);
    }
    setShowNavigationAlert(true);
    }
    setShowVideoLibraryModal(false);
    setVideoErrors({ ...videoErrors, selectedOptions: false });
    setSelectedRelatedVideoIndex(null);
};

const deleteRelatedVideo = (videoObjId) => {
    if (data?._id) {
    dispatch(
        deleteVideosrelatedAction({
        apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoObjId,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Related Video Removed Successfully!", 1);
            setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
            } else {
            Toastiy("Failed to Delete Video");
            }
        },
        })
    );
    } else {
    setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
    }
    setSelectedRelatedVideoIndex(null);
};


const getAllLanguageResponse = (response) => {
    if (response?.type === 1) {
    setReadLanguageData(response?.data);
    setLoading(false);
    }
};

const handleInputChange = (event, setState) => {
    const { name, value } = event.target;

    if (typeof setState === "function") {
      setState((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    if (name === "webUploadUrl" || name === "logoUrl") {
      setChurchInputs((prev) => ({
        ...prev,
        logo_url: value,
        church_logo_urls: value,
      }));
          }

    setShowNavigationAlert(true);
};

const handleDownloadInputChange = (event) => {
    const { name, value } = event.target;
    setDownloadUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_download_urls: false });
    setShowNavigationAlert(true);
};

const handleTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setTumbNailUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleCommonTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setCommonUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleChange = (event) => {
    const { name, value } = event.target;
        setChurchInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));
setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
};

const handleFileInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);

    const callback = (res) => {
      // ✅ log the uploaded file URL
            setChurchInputs((prev) => ({
        ...prev,
        logo_url: res?.url,   // 👈 directly update logo_url
      }));
            // ✅ 1. update preview state
      setState((prevInputs) => ({
        ...prevInputs,
        [keyName]: res?.url,
      }));

      // ✅ 2. update churchInputs with only the web URL
      if (keyName === "webUploadUrl") {
        setChurchInputs((prevInputs) => ({
          ...prevInputs,
          church_logo_urls: res?.url, // store only web logo URL
        }));
      }

      setVideoErrors({ ...videoErrors, [errorKeyName]: false });
      setLoading(false);
      setShowNavigationAlert(true);
    };

    if (type === "videos") {
      dispatch(
        uploadVideosV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback,
        })
      );
    } else {
      dispatch(
        uploadAssestsV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback,
        })
      );
    }
  };



const handleFileDownloadInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setDownloadUrl(res?.url);
        setDownloadUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_download_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setDownloadValues(value);
};

const handleFiletumbNailInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setThumbNailUrl(res?.url);
        setTumbNailUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setThumbNailValues(value);
};

const handleRelatedVideosChange = (selectedOptions) => {
    setInputs((prevInputs) => ({
    ...prevInputs,
    [activeTab]: {
        ...prevInputs[activeTab],
        relatedVideos: selectedOptions.map((option) => option.value),
    },
    }));
    setShowNavigationAlert(true);
    // setVideoErrors({ ...videoErrors, selectedOptions: false });
};

const handleVideoDescriptionChange = (e) => {
    handleInputChange(activeTab, "videoDescription", e.target.value);
    setShowNavigationAlert(true);
};

const videoData =
    videoUrlsInputs.mobileUploadUrl !== ""
    ? videoUrlsInputs.mobileUploadUrl
    : videoUrlsInputs.webUploadUrl !== ""
    ? videoUrlsInputs.webUploadUrl
    : videoUrlsInputs.tabletUploadUrl;

const downloadData =
    UdownloadrlsInputs.mobileUploadUrl !== ""
    ? UdownloadrlsInputs.mobileUploadUrl
    : UdownloadrlsInputs.webUploadUrl !== ""
    ? UdownloadrlsInputs.webUploadUrl
    : UdownloadrlsInputs.tabletUploadUrl;

const tumbNailData =
    tumbNailUrlsInputs.mobileUploadUrl !== ""
    ? tumbNailUrlsInputs.mobileUploadUrl
    : tumbNailUrlsInputs.webUploadUrl !== ""
    ? tumbNailUrlsInputs.webUploadUrl
    : tumbNailUrlsInputs.tabletUploadUrl;


   const handleSave = async ({ onSuccess, onClose } = {}) => {
              if (typeof setSavingChurch === "function") setSavingChurch(true);

              return new Promise((resolve, reject) => {
                const callback = (res) => {
                  if (typeof setSavingChurch === "function") setSavingChurch(false);

                  if (res?.type === 1) {
                    // ✅ Church saved successfully
                    const savedChurch = res?.data?.[0]; // Get first church from array

                    // ✅ Store in localStorage
                    localStorage.setItem("channel", JSON.stringify(savedChurch));
                    toast.success("Channel saved successfully!", {
                      position: "top-right",
                      autoClose: 3000,
                    });

                    // ✅ Reset inputs
                    if (typeof setChurchInputs === "function")
                      setChurchInputs(initialChurchValues || {});
                    if (typeof setSaveSuccess === "function") {
                      setSaveSuccess(true);
                      setTimeout(() => setSaveSuccess(false), 2000);
                    }

                    // ✅ Call onSuccess & onClose callbacks if provided
                    if (typeof onSuccess === "function") onSuccess(res);
                    setTimeout(() => {
                      if (typeof onClose === "function") onClose();
                    }, 500);

                    resolve(res);
                  } else {
                    // ❌ Church save failed
                    toast.error("Failed to save church.", {
                      position: "top-right",
                      autoClose: 3000,
                    });
                    reject(res);
                  }
                };

                // ✅ Prepare main church payload
                const payload = {
                  typeofentity:'2',
                  churchName: churchInputs?.church_title || "",
                  tagline: churchInputs?.church_tagline || "",
                  description: churchInputs?.church_description || "",
                  logourl: churchInputs?.logo_url || "",
                  address: churchInputs?.church_address || "",
                  latitude: churchInputs?.church_latitude || "",
                  longitude: churchInputs?.church_longitude || "",
                  contactemail: churchInputs?.church_email || "",
                  contactphone: churchInputs?.church_phone || "",
                  website: churchInputs?.church_website || "",
                  giveUrl:churchInputs?.church_giver_url
                };


                // ✅ Dispatch Church Save request only
                dispatch(saveChannelRequest(payload, callback));
              });
            };

     const handleUpdateChurch = (rowData) => {

                return new Promise((resolve, reject) => {

                  setSavingChurch(true);

                  // ✅ Build payload matching Swagger field names
                  const payload = {
                    _id: rowData?._id || "",
                    churchName: churchInputs?.church_title || rowData?.churchName || "",
                    tagline: churchInputs?.church_tagline || rowData?.tagline || "",
                    description: churchInputs?.church_description || rowData?.description || "",
                    logourl: churchInputs?.logo_url || rowData?.logourl || "",
                    address: churchInputs?.church_address || rowData?.address || "",
                    latitude: churchInputs?.church_latitude || rowData?.latitude || "",
                    longitude: churchInputs?.church_longitude || rowData?.longitude || "",
                    contactemail: churchInputs?.church_email || rowData?.contactemail || "",
                    contactphone: churchInputs?.church_phone || rowData?.contactphone || "",
                    website: churchInputs?.church_website || rowData?.website || "",
                    giveUrl: churchInputs?.church_giver_url || rowData?.giveUrl || "",

                  };


                  const callback = (res) => {
                    setSavingChurch(false);

                    if (res.type === 1) {
                      toast.success("Church updated successfully!");
                      navigate("/channel/all");
                      resolve(res);
                    } else {
                      toast.error("Failed to update church");
                      reject(res);
                    }
                  };

                  // ✅ Dispatch update request
                  dispatch(updateChannelRequest(payload, callback));
                });
              };


useEffect(() => {
    setLoading(true);
    dispatch(
    readLanguageAction({
        callback: getAllLanguageResponse,
    })
    );
}, []);

const fetchVideoDetails = () => {
    dispatch(
    readVideosAction({
        apiPayloadRequest: {
        _id: data?._id,
        },
        callback: (res) => {
        const data = res?.data[0];

        setCurrentInputs({
            _id: data?._id,
            video_title: data?.video_title || "",
            video_description: data?.video_description || "",
            totalLikes: data?.totallikes || 0,
            totalViews: data?.video_views || 0,
        });

        setLanguagemeta(data?.languagemetas);
        setVideoUrlsInputsCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl: data?.urls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setDownloadUrlsInputsCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setTumbNailUrlsInputsCheck({
            mobileUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setCommonUrlsInputsCheck({
            mobileUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link ||
            "",
            webUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link ||
            "",
            tabletUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link ||
            "",
        });

        setPreviewUrlsInputsCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        const relatedVideos = data?.relatedvideos ?? [];
        const relatedVideosList = [];
        relatedVideos.map((item) => {
            relatedVideosList.push({
            value: item?.videoObjId?._id,
            label: item?.videoObjId?.video_title,
            image: item?.videoObjId?.tumbnailurls[0].url_link,
            });
        });
        setSelectedOptions(relatedVideosList);
        },
    })
    );
};

const fetchVideoLayouts = () => {
    dispatch(
    readVideoLayoutAction({
        apiPayloadRequest: {
        videoObjId: data?._id,
        },
        callback: (res) => {
        if (res?.type === 1) {
                        res?.data.forEach((layout) => {
            const requiredData = layout.videos.filter((item) => item.videoObjId === data?._id);

            const requiredId = layout._id;
            const requiredMobileLayout = layout.mobile_layout;
            const requiredName = layout.layout_name;

            requiredData.map((item) => {
                setLayoutArray((prev) => [
                ...prev,
                {
                    _id: requiredId,
                    mobile_layout: requiredMobileLayout,
                    layout_name: requiredName,
                    order: item.order,
                    // title: item.title,
                    // subtitle: item.subtitle,
                    // expiry: item.expiry,
                },
                ]);
            });
            });
        }
        },
    })
    );
};

// useEffect(() => {
//     if (data?._id !== "" && data?._id !== undefined) {
    // setTimeout(() => {
    //   dispatch(readVideosAction({ callback: getRelatedVideos }));
    // }, 2000);

//     fetchVideoDetails();
//     fetchVideoLayouts();
//     } else {
//     dispatch(readVideosAction({ callback: getRelatedVideos }));
//     }
// }, []);

const [isLanguageSave, setIsLanguageSave] = useState(true);
const [currentLanguageInputs, setCurrentLanguageInputs] = useState();
const [currentLanguageUrlCheck, setCurrentLanguageUrlCheck] = useState();
const [currentLanguageDownloadUrlCheck, setCurrentLanguageDownloadUrlCheck] = useState();
const [currentLanguagePreviewUrlCheck, setCurrentLanguagePreviewUrlCheck] = useState();


useEffect(() => {
    if (activeTab === "en") {
    if (currentInputs) {
        setVideoInputs(currentInputs);
    }
    if (videoUrlsInputsCheck) {
        setVideoUrlsInputs(videoUrlsInputsCheck);
    }
    if (UdownloadrlsInputsCheck) {
        setDownloadUrlsInputs(UdownloadrlsInputsCheck);
    }
    if (tumbNailUrlsInputsCheck) {
        setTumbNailUrlsInputs(tumbNailUrlsInputsCheck);
    }
    if (commonUrlsInputsCheck) {
        setCommonUrlsInputs(commonUrlsInputsCheck);
    }
    if (previewUrlsInputsCheck) {
        setPreviewUrlsInputs(previewUrlsInputsCheck);
    }
    } else {
    const isPresent = languagemeta?.some((language) => language?.language_code === activeTab);
    if (isPresent) {
        const data = languagemeta?.filter((item) => item?.language_code === activeTab)[0];

        setVideoInputs((prev) => ({
        ...prev,
        video_title: data?.video_title || "",
        video_description: data?.video_description || "",
        }));
        setCurrentLanguageInputs((prev) => ({
        ...prev,
        video_title: data?.video_title || "",
        video_description: data?.video_description || "",
        }));

        if (data?.urls?.length > 0) {
        setVideoUrlsInputs({
            mobileUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguageUrlCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setVideoUrlsInputs(initialStateValues);
        setCurrentLanguageUrlCheck(initialStateValues);
        }
        if (data?.downloadurls?.length > 0) {
        setDownloadUrlsInputs({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguageDownloadUrlCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setDownloadUrlsInputs(initialStateValues);
        setCurrentLanguageDownloadUrlCheck(initialStateValues);
        }
        if (data?.trailers?.length > 0) {
        setPreviewUrlsInputs({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguagePreviewUrlCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setPreviewUrlsInputs(initialStateValues);
        setCurrentLanguagePreviewUrlCheck(initialStateValues);
        }
    } else {
        setVideoInputs(currentInputs);
        setCurrentLanguageInputs(currentInputs);
        setVideoUrlsInputs(initialStateValues);
        setCurrentLanguageUrlCheck(initialStateValues);
        setDownloadUrlsInputs(initialStateValues);
        setCurrentLanguageDownloadUrlCheck(initialStateValues);
        setPreviewUrlsInputs(initialStateValues);
        setCurrentLanguagePreviewUrlCheck(initialStateValues);
    }
    }
}, [
    activeTab,
    videoUrlsInputsCheck,
    UdownloadrlsInputsCheck,
    tumbNailUrlsInputsCheck,
    commonUrlsInputsCheck,
    previewUrlsInputsCheck,
]);


const handleSaveLanguage = async () => {
    const requestsList = [];
    if (isLanguageSave) {
    const keysArray = Object.keys(videoUrlsInputs);

    requestsList.push(
        new Promise((resolve, reject) => {
        dispatch(
            saveVideoLanguageAction({
            apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
            },
            callback: (res) => {
                if (res?.type === 1) {
                Toastiy("Video Language Saved Successfully", 1);
                setShowNavigationAlert(false);
                }
                resolve();
            },
            })
        );
        })
    );

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (videoUrlsInputs[item]) {
                dispatch(
                saveVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 500);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (UdownloadrlsInputs[item]) {
                dispatch(
                saveDownloadVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Download URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 600);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (previewUrlsInputs[item]) {
                dispatch(
                saveVideoPreviewLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Preview URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 650);
        })
        );
    });
    } else {
    const keysArray = Object.keys(videoUrlsInputs);

    if (
        videoInputs?.video_title !== currentLanguageInputs?.video_title ||
        videoInputs?.video_description !== currentLanguageInputs?.video_description
    ) {
        requestsList.push(
        new Promise((resolve, reject) => {
            dispatch(
            updateVideoLanguageAction({
                apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
                },
                callback: (res) => {
                if (res?.type === 1) {
                    Toastiy("Video Language Updated Successfully", 1);
                    setShowNavigationAlert(false);
                }
                resolve();
                },
            })
            );
        })
        );
    }

    keysArray.map((item) => {
        if (!currentLanguageUrlCheck[item] && videoUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        videoUrlsInputs[item] &&
        videoUrlsInputs[item] !== currentLanguageUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguageDownloadUrlCheck[item] && UdownloadrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        UdownloadrlsInputs[item] &&
        UdownloadrlsInputs[item] !== currentLanguageDownloadUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguagePreviewUrlCheck[item] && previewUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        previewUrlsInputs[item] &&
        previewUrlsInputs[item] !== currentLanguagePreviewUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });
    }

    await Promise.all(requestsList);
    fetchVideoDetails();
};

const handleLibraryVideoSelection = (details) => {
        setVideoInputs((prev) => ({
    ...prev,
    video_title: details?.video_title,
    video_description: details?.video_description,
    }));
    setVideoUrlsInputs({
    mobileUploadUrl: details?.urls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.urls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.urls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setDownloadUrlsInputs({
    mobileUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setTumbNailUrlsInputs({
    mobileUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setCommonUrlsInputs({
    mobileUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setShowNavigationAlert(true);
};

const handleSendNotification = () => {
    dispatch(
    sendCustomNotificationAction({
        apiPayloadRequest: {
        _id: data?._id,
        type: "2",
        },
        callback: (res) => {
        if (res?.type === 1) {
            Toastiy("Notification Sent Successfully", 1);
        }
        },
    })
    );
};

return {
    value,
    onChangeSearchBar,
    languages,
    activeTab,
    setActiveTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    inputs,
    handleInputChange,
    handleFileInputChange,
    handleRelatedVideosChange,
    handleVideoDescriptionChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    videoUrlsInputs,
    handleFileDownloadInputChange,
    handleFiletumbNailInputChange,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    handleTumbNailInputChange,
    handleDownloadInputChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    setEditLayoutIndex,
    isLayoutEdit,
    handleLayoutUpdate,
    setEditTargetLayout,
    editTargetLayout,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    currentInputs,
    handleSendNotification,
    churchInputs, // instead of videoInputs
    churchErrors, // instead of videoErrors
    handleChange,
    handleSave,
    handleUpdateChurch,
    imageSet,setimageSet
};
};
